import ready, { HTML } from 'Utils';
import initHeaderSticky from './components/headerSticky';
import initAccessibilityNav from './components/AccessibilityNav';
import initBurgerMenu from './components/BurgerMenu';
import initCollapsible from './components/Collapsible';
import initHeaderFocus from './components/headerFocus';
import initAccordion from './components/accordion';
import initCounter from './components/counter';
import initSlider from './components/slider';
import initTabs from './components/tabs';
import initSelect from './components/selectForTabs';
import initFancybox from './components/fancybox';
import initScrollLinks from './components/scrollLinks';
import initSelects from './components/selects';
import initCalendar from './components/calendar';
import initScheduleModal from './components/scheduleModal';
import initDatepicker from './components/datepicker';
import initSelectLocation from './components/selectLocation';
import initMap from './components/googleMap';
import initReadMoreLess from './components/readMoreLess';
import initInputFile from './components/inputFile';
import initPasswordToggle from './components/passwordToggle';
import initOpenClose from './components/openClose';
import initTimer from './components/timer';
import initCopyBtn from './components/сopyBtn';
import initRefreshPage from './components/refreshPage';
import initFormValidation from './components/FormValidation';
import { initFixedBreadcrumbs } from './components/fixedBreadcrumbs';
import { initFormContact } from './components/formContact';
import initInputTel from './components/inputTel';
import initScheduleStep from './components/scheduleStep';

ready(() => {
  HTML.classList.add('is-loaded');
  initHeaderSticky();
  initAccessibilityNav();
  initBurgerMenu();
  initCollapsible();
  initHeaderFocus();
  initAccordion();
  initCounter();
  initSlider();
  initTabs();
  initSelect();
  initFancybox();
  initScrollLinks();
  initSelects();
  initCalendar();
  initScheduleModal();
  initMap();
  initDatepicker();
  initSelectLocation();
  initReadMoreLess();
  initInputFile();
  initPasswordToggle();
  initOpenClose();
  initTimer();
  initCopyBtn();
  initRefreshPage();
  initFormValidation();
  initFixedBreadcrumbs();
  initFormContact();
  initInputTel();
  initScheduleStep();
});
